import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, NavigationEnd, Params, Router } from "@angular/router"

@Injectable({
  providedIn: "root",
})
export class TrRouteParams {
  public params: Params = {}
  public queryParams: Params = {}

  constructor(private router: Router) {
    this.updateRouteParams()
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateRouteParams()
      }
    })
  }

  public updateRouteParams(): void {
    const routeParams = this.getCurrentRouteParams()
    this.params = routeParams.params
    this.queryParams = routeParams.queryParams
  }

  public getCurrentRouteParams(): { params: Params, queryParams: Params } {
    return this.collectParams(this.router.routerState.snapshot.root)
  }

  private collectParams(root: ActivatedRouteSnapshot): { params: Params, queryParams: Params } {
    return this.mergeParamsFromSnapshot(root)
  }

  private mergeParamsFromSnapshot(
    snapshot: ActivatedRouteSnapshot,
    params: Params = {},
    queryParams: Params = {},
  ): { params: Params, queryParams: Params } {
    params = { ...params, ...snapshot.params }
    queryParams = { ...queryParams, ...snapshot.queryParams }
    snapshot.children.forEach(nextSnapshot => {
      const paramsInfo = this.mergeParamsFromSnapshot(nextSnapshot, params, queryParams)
      params = paramsInfo.params
      queryParams = paramsInfo.queryParams
    })

    return { params, queryParams }
  }
}
